import React from "react";
import { Rate, Table, Image } from "antd";
import { rateSetModel } from "../rateSetModel";
import { ColumnsType } from "antd/es/table";
import { IMdUserDetail, IRateItem } from "../rateSetTypes";
import moment from "moment";
import { YhBut } from "@src/components/YhButton";
import { EditModeType } from "@src/types/FmsTypes";
import { getBaseImgLookUrl } from "@src/utils/constants";

export function DataTable() {
  const {
    dataSource,
    pgCfg,
    loadData,
    setDrawerVisible,
    setSelectedRow,
    setEditType,
  } = rateSetModel();
  const onDetail = (type: EditModeType, data: IMdUserDetail) => {
    setDrawerVisible(true);
    setSelectedRow(data);
    setEditType(type);
  };

  const columns: ColumnsType<IMdUserDetail> = [
    {
      align: "center",
      title: "序号",
      width: 60,
      render: (v, r, i) => i + 1,
    },

    {
      align: "center",
      title: "系统名称",
      width: 150,
      dataIndex: "appName",
    },
    {
      align: "left",
      title: "反馈内容",
      width: 200,
      dataIndex: "content",
      render: (v: any, r: any, i: any) => <span style={{lineHeight: '22px'}}>{v}</span>,
    },
    {
      align: "center",
      title: "评价类型",
      width: "300px",
      dataIndex: "indicatorList",
      render: (v, r, i) =>
        v.map((item: any) => (
          <div style={{ display: "flex" }}>
            <span style={{ width: "120px", textAlign: 'right',paddingRight: '15px' }}>{item.indicatorName}</span>
            <Rate value={item.indicatorScore} />
          </div>
        )),
    },
    {
      align: "left",
      title: "附件",
      width: 300,
      dataIndex: "attachmentList",
      render: (v, r, i) =>
        v.map((item: any) => (
            <div style={{margin: "10px", float: "left", width: "50px"}}>
                <Image width={50} src={getBaseImgLookUrl(item.fileMd5)}  />
            </div>
          
        )),
    },
    {
      align: "center",
      title: "反馈人",
      width: 120,
      dataIndex: "createUser",
    },
    {
      align: "center",
      title: "反馈时间",
      width: 200,
      dataIndex: "createTime",
      render: (value) => value ? `${value[0]}-${value[1]}-${value[2]} ${value[3]}:${value[4]}:${value[5]}` : '',
    },
  ];

  return (
    <Table
      style={{ cursor: "pointer" }}
      columns={columns}
      dataSource={dataSource}
      pagination={{
        ...pgCfg,
        position: ["bottomCenter"],
        onChange: (pageNum, pageSize) => {
          loadData({ pageNum, pageSize }).then();
        },
      }}
      scroll={{ x: "max-content" }}
    />
  );
}
